import TextLongWidget from '~/jobiqo/components/Form/Widgets/TextLong';
import JobFormAIGenerateDescription from '../components/AIJobDescriptionButton';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { isRecruiter } from '~/jobiqo/lib/auth';
import { getCurrentFrontendConfig } from '~/jobiqo/context/frontendConfig';

/**
 * Renders the overrides for a job description button to generate via AI.
 */
export function getAIJobDescription(user) {
  const aiJobDescriptionConfig =
    getCurrentFrontendConfig().JOBS.AI?.JOB_DESCRIPTION || {};
  return (
    aiJobDescriptionConfig.enabled &&
    (isRecruiter(user) ||
      aiJobDescriptionConfig.dangerous_enabled_anonymous) && {
      field_job_description: ({ field, values, setFieldValue }) => {
        return (
          <div key={field.id}>
            <TextLongWidget entityField={field} />
            <JobFormAIGenerateDescription />
            <Spacing size="medium" />
          </div>
        );
      },
    }
  );
}
